import { getCollectionsByType } from '@api/collections/getCollectionsByType';
import { useQuery } from 'react-query';

export function useGetMarkets(enabled = true) {
  return useQuery('getMarkets', () => getCollectionsByType(['market']), {
    enabled,
    refetchOnWindowFocus: false,
  });
}
